/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import "@fontsource/roboto";
import { TDocumentDefinitions } from 'pdfmake/interfaces';

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

interface Causalidade {
    ramPor: string;
    ramParaAvaliar: string;
    pergunta1: string;
    pergunta2: string;
    pergunta3: string;
    pergunta4: string;
    pergunta5: string;
    pergunta6: string;
    pergunta7: string;
    pergunta8: string;
    pergunta9: string;
    pergunta10: string;
    tipoReaccao: string;
}

const AnaliseNaranjoPdf = async (causalidade: Causalidade) => {

    pdfMake.fonts = {
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const docDefinition: TDocumentDefinitions = {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 40],
        content: [
            {
                text: 'Causalidade de RAM de acordo com o Algoritmo de Naranjo e Colab',
                style: 'title',
                alignment: 'center',
                margin: [0, 0, 0, 20]
            },
            {
                text: `RAM por: ${causalidade?.ramPor || ''}`,
                style: 'body',
                margin: [0, 0, 0, 5]
            },
            {
                text: `RAM para avaliar: ${causalidade?.ramParaAvaliar || ''}`,
                style: 'body',
                margin: [0, 0, 0, 15]
            },
            {
                table: {
                    headerRows: 1,
                    widths: ['*', 50, 50, 60, 60],
                    body: [
                        [
                            { text: 'Perguntas', style: 'tableHeader', bold: true },
                            { text: 'Sim', style: 'tableHeader', bold: true, alignment: 'center' },
                            { text: 'Não', style: 'tableHeader', bold: true, alignment: 'center' },
                            { text: 'Não sabe', style: 'tableHeader', bold: true, alignment: 'center' },
                            { text: 'Pontos', style: 'tableHeader', bold: true, alignment: 'center' }
                        ],
                        [
                            { text: '1. Existem estudos prévios sobre essa reacção?', style: 'tableBody' },
                            { text: '+1', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta1}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ],
                        [
                            { text: '2. A reacção adversa ocorreu após administração do medicamento?', style: 'tableBody' },
                            { text: '+2', alignment: 'center' },
                            { text: '-1', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta2}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ],
                        [
                            { text: '3. O paciente melhora quando o medicamento é retirado ou quando se administra um antagonista específico?', style: 'tableBody' },
                            { text: '+1', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta3}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ],
                        [
                            { text: '4. A reacção reaparece quando se readministra o medicamento?', style: 'tableBody' },
                            { text: '+2', alignment: 'center' },
                            { text: '-1', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta4}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ],
                        [
                            { text: '5. Excluindo o uso de medicamentos, existem outras causas capazes de determinar o surgimento da reacção?', style: 'tableBody' },
                            { text: '-1', alignment: 'center' },
                            { text: '+2', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta5}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ],
                        [
                            { text: '6. A reacção reaparece ao se administrar placebo?', style: 'tableBody' },
                            { text: '-1', alignment: 'center' },
                            { text: '+1', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta6}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ],
                        [
                            { text: '7. O medicamento foi detectado em sangue ou outros líquidos orgânicos, em concentrações consideradas tóxicas?', style: 'tableBody' },
                            { text: '+1', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta7}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ],
                        [
                            { text: '8. A reacção foi mais intensa quando se aumentou a dose ou menos intensa quando a dose foi reduzida?', style: 'tableBody' },
                            { text: '+1', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta8}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ],
                        [
                            { text: '9. O paciente já apresentou alguma reacção semelhante ao mesmo medicamento ou a outro similar?', style: 'tableBody' },
                            { text: '+1', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta9}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ],
                        [
                            { text: '10. A reacção adversa foi confirmada por meio de alguma evidência objectiva?', style: 'tableBody' },
                            { text: '+1', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: '0', alignment: 'center' },
                            { text: `${causalidade?.pergunta10}`, fillColor: '#f0f0f0', alignment: 'center' }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 20]
            },
            {
                table: {
                    widths: [130, 140],
                    body: [
                        [
                            { text: '', colSpan: 2, border: [false, false, false, false], style: 'tableBody2' },
                            {}
                        ],
                        [
                            { text: 'Legenda', colSpan: 2, alignment: 'center', bold: true, fillColor: '#e0e0e0', fontSize: 11, },
                            {}
                        ],
                        [
                            { text: 'Pontuação', alignment: 'center', bold: true, fillColor: '#f0f0f0', style: 'tableBody2' },
                            { text: 'Tipo de reacção', alignment: 'center', bold: true, fillColor: '#f0f0f0', style: 'tableBody2' }
                        ],
                        [
                            { text: '≥ 9', alignment: 'center', style: 'tableBody2' },
                            { text: 'Definida (provada)', alignment: 'center', style: 'tableBody2' }
                        ],
                        [
                            { text: 'entre 5 e 8', alignment: 'center', style: 'tableBody2' },
                            { text: 'Provável', alignment: 'center', style: 'tableBody2' }
                        ],
                        [
                            { text: 'entre 1 e 4', alignment: 'center', style: 'tableBody2' },
                            { text: 'Possível', alignment: 'center', style: 'tableBody2' }
                        ],
                        [
                            { text: '≤ 0', alignment: 'center', style: 'tableBody2' },
                            { text: 'Duvidosa', alignment: 'center', style: 'tableBody2' }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [30, 0, 0, 20]
            },
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                stack: [
                                    { text: 'Avaliação de causalidade:', bold: true, margin: [0, 0, 0, 5] },
                                    { text: `${causalidade?.tipoReaccao}`, margin: [5, 0, 0, 15] }
                                ],
                                margin: [10, 10, 10, 10]
                            }
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                }
            }
        ],
       
        styles: {
            title: {
                fontSize: 14,
                bold: true
            },
            body: {
                fontSize: 11,
                lineHeight: 1.3
            },
            tableHeader: {
                fontSize: 10,
                fillColor: '#e0e0e0'
            },
            tableBody: {
                fontSize: 10,
                lineHeight: 1.3,
                margin: [0, 0, 0, 2]
            },
            tableBody2: {
                fontSize: 8,
                lineHeight: 1.2
            }
        },
        defaultStyle: {
            font: 'Roboto',
        }
    };

    pdfMake.createPdf(docDefinition).open();
};

export {
    AnaliseNaranjoPdf,
};